// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"583":"3bc2c958","787":"a227f313","975":"4435f067"}[chunkId] + ".chunk.js";
};